import { render, staticRenderFns } from "./About.vue?vue&type=template&id=497a9196&scoped=true&lang=pug&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=497a9196&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497a9196",
  null
  
)

export default component.exports